const key = {
  SET_AUTH: "SET_AUTH",
  LOG_OUT: "LOG_OUT",
  SET_BLOCK: "SET_BLOCK",
  SET_CHANNEL: "SET_CHANNEL",
  SET_LEAGUE: "SET_LEAGUE"
}

export default key
